//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_kontaktpersonerpaansokan {
	Fackligrepresentant = 866190000,
	Fretagsrepresentant = 866190100,
	CSN = 866190300,
	Deltagare = 866190400,
	Partsgemensamt = 866190500,
	Coach = 866190600,
	InterntTSL = 866190700,
	Konkursbevakning = 866190800,
};
